module.exports = __webpack_public_path__ + "img/SKMJ_car1.559e6475.jpg";